import { MonthSubcontractorScheduleStateTypes, MonthSubcontractorScheduleActionTypes } from "./MonthSubcontractorSchedule.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MonthSubcontractorScheduleStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MonthSubcontractorScheduleReducer = (
  state: MonthSubcontractorScheduleStateTypes = INITIAL_STATE,
  action: any
): MonthSubcontractorScheduleStateTypes => {
  switch (action.type) {
    case MonthSubcontractorScheduleActionTypes.FETCH_ALL_MONTH_SUBCONTRACTOR_SCHEDULE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MonthSubcontractorScheduleActionTypes.FETCH_ALL_MONTH_SUBCONTRACTOR_SCHEDULE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MonthSubcontractorScheduleActionTypes.FETCH_ALL_MONTH_SUBCONTRACTOR_SCHEDULE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MonthSubcontractorScheduleActionTypes.FETCH_ALL_MONTH_SUBCONTRACTOR_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MonthSubcontractorScheduleActionTypes.FETCH_ONE_MONTH_SUBCONTRACTOR_SCHEDULE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MonthSubcontractorScheduleActionTypes.FETCH_ONE_MONTH_SUBCONTRACTOR_SCHEDULE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MonthSubcontractorScheduleActionTypes.FETCH_ONE_MONTH_SUBCONTRACTOR_SCHEDULE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MonthSubcontractorScheduleActionTypes.FETCH_ONE_MONTH_SUBCONTRACTOR_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MonthSubcontractorScheduleReducer;
